/**
 * Services Module
 *
 * @version 1.0
 * @module core/modules/services
 *
 * @description
 * Módulo de Servicios Públicos: agua, cloacas, electricidad, gas.
 * Auto-registro en el moduleRegistry al importarse.
 */

import { moduleRegistry } from '../../module-registry';
import { ServicesTabbedPanel } from './ServicesTabbedPanel';

export { ServicesTabbedPanel };

/* ===== AUTO-REGISTRO DEL MÓDULO ===== */

moduleRegistry.register({
  id: 'services',
  leftPanel: ServicesTabbedPanel,
  enabledByDefault: false,
});
